module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABAElEQVQ4jZWTPStGYRjHf8/tRE9KGUxeUsrgI1hZ2I0mH8EzP8kHsJiUSSZZ7GxK+QgkgyhkIMXA87Ocu26ncx/Hv66u4f9y3a8dlQrmgQ1gGZgFCuABuAQOgLNfajWtbf/GkToaPal5v4U54lodSwO2MsI9tacOariLGDDVMKlbDnjK8GsB2KyeYoLpsn9l+H4AVhoCQqVXsRCAyYaA77IPMvxHAIYaAu7LXmT4QQE8AzMZwSFwB0xk+C7qcYt7z+ExADsNW5gDOsB7ht+ND+kkM6GnrqqfNdyLGmLAiHrzz+UvWvkL4+ppC+OtumTNZ4q1rp6rr+pbUldqXx1O9T/jOCc634gweAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/operation-tips.png
// module id = +oj/
// module chunks = 1